module.exports = __webpack_public_path__ + "img/work_from_anywhere6.73439a65.png";